// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconOutdent, iconOutdentTag } from '@ni/nimble-components/dist/esm/icons/outdent';
import { wrap } from '../../utilities/react-wrapper';

export type { IconOutdent };
export { iconOutdentTag };
export const NimbleIconOutdent = wrap(IconOutdent);